<div class="bus-snackbar" *ngIf="visible" role="status" tabindex="0" (click)="open()" (keydown.enter)="open()">
  <ng-container *ngIf="processing; else completed">
    <i class="fa fa-spinner fa-spin bus-icon"></i>
    <div class="bus-text">
      <div class="bus-title">{{ progress?.processedResumes > 0 ? 'Processing resumes' : 'Uploading resumes' }}</div>
      <div class="bus-sub">{{ progress?.processedResumes }} of {{ progress?.totalResumes }} processed &middot; {{ progress?.uploadedResumes }} uploaded</div>
      <div class="bus-bar"><div class="bus-bar-fill" [style.width.%]="progress?.progressPercentage"></div></div>
    </div>
  </ng-container>
  <ng-template #completed>
    <i class="fa fa-check-circle bus-icon bus-icon-done"></i>
    <div class="bus-text">
      <div class="bus-title">Bulk upload completed</div>
      <div class="bus-sub">{{ summary?.message || 'Click to view the summary' }}</div>
    </div>
  </ng-template>
</div>
